import { AccessMode } from '../documentsAndClauses/list.types';
import { ValidationError } from '../documents/documents.list.types';
import { BOOLEAN_VALUES } from '../../../components/UploadFiles/MetadataForm/MetadataFormHelpers';

export type DocumentDownloadResponse = {
  document_id: string;
  url: string;
};

export interface DictionariesParams {
  AccessMode: AccessMode;
  Draft?: BOOLEAN_VALUES;
}

export type MetadataDictionaryValue = {
  label: string;
  value: string;
  related?: MetadataDictionaryRelated;
  validation_rules?: MetadataDictionaryValidationRule[];
  disabled?: boolean;
};

export interface MetadataDictionaryRelated {
  Classification?: string[];
  Lop?: string[];
  Country?: string;
  Language?: string;
  Lob?: string[];
  BusinessType?: string | string[];
}

export type RelatedValidationRule = Partial<Record<'Lop' | 'BusinessType', string[]>>;

export interface MetadataDictionaryValidationRule {
  type: string;
  values: string[];
  related: RelatedValidationRule;
}

export type MetadataDictionary = {
  required: boolean;
  values: MetadataDictionaryValue[];
};

export type DictionariesResponse = {
  Active: MetadataDictionary;
  BusinessType: MetadataDictionary;
  Classification: MetadataDictionary;
  Country: MetadataDictionary;
  DocumentType: MetadataDictionary;
  Entity: MetadataDictionary;
  ExpireAt: MetadataDictionary;
  Language: MetadataDictionary;
  LatestVersion: MetadataDictionary;
  Lob: MetadataDictionary;
  Lop: MetadataDictionary;
  Remarks: MetadataDictionary;
  ReportedReason: MetadataDictionary;
  ValidFrom: MetadataDictionary;
  ValidTo: MetadataDictionary;
  Version: MetadataDictionary;
  ProductType: MetadataDictionary;
  InsurerIndustry: MetadataDictionary;
};

export type ClauseDictionariesResponse = {
  BusinessTypes: MetadataDictionary;
  Classification: MetadataDictionary;
  ClauseNumber: MetadataDictionary;
  ClauseSources: MetadataDictionary;
  ClauseStatus: MetadataDictionary;
  ClauseTypes: MetadataDictionary;
  Countries: MetadataDictionary;
  Entities: MetadataDictionary;
  IndividualizationReason: MetadataDictionary;
  Language: MetadataDictionary;
  Lobs: MetadataDictionary;
  Lops: MetadataDictionary;
  ReportedReason: MetadataDictionary;
  Provider: MetadataDictionary;
};

export type DictionariesResponseKeys = keyof DictionariesResponse;

export interface UploadedFileRequest {
  DocumentId: string;
  FileName: string;
  Entity?: string;
  Country?: string;
  Lob?: string;
  Lop?: string;
  BusinessType?: string;
  DocumentType?: string;
  Classification?: string;
  Language?: string;
  Active?: string;
  ValidFrom?: string;
  ValidTo?: string;
  ExpireAt?: string;
  Version?: string;
  LatestVersion?: string;
  Remarks?: string;
  VersionKey?: string;
  Errors?: ValidationError[];
}

export const UPDATE_METADATA_CACHE_KEY = 'update_metadata_cache_key';

export enum LIST_API_TAGS {
  LIST = 'List',
  FILE = 'File',
}

export enum LIST_API_ENDPOINTS {
  GET_LIST = 'getList',
}

export interface ReportedReason {
  required: boolean;
  values: Array<{
    label: string;
    value: string;
  }>;
}

export enum PROVIDER {
  GPC = 'GPC',
  COMPLIANCE = 'COMPLIANCE',
  DEFAULT = 'default',
}
